import type { FunctionComponent } from "react"

import { Layout, LAYOUT_COLOR_BLOCK } from "@jobteaser/ui-kit/components/Layout/Layout"

import { ArticlesEmptyStates } from "@/features/companyDetail/components/NewsFeed/ArticlesEmptyStates/ArticlesEmptyStates"
import { ArticlesFilters } from "@/features/companyDetail/components/NewsFeed/ArticlesFilters/ArticlesFilters"
import { ArticleListing } from "@/features/companyDetail/components/NewsFeed/ArticlesListing/ArticleListing"
import { ArticlesLoading } from "@/features/companyDetail/components/NewsFeed/ArticlesListing/ArticlesLoading"
import { ArticlesTitle } from "@/features/companyDetail/components/NewsFeed/ArticlesTitle/ArticlesTitle"
import { EventListing } from "@/features/companyDetail/components/NewsFeed/EventsListing/EventListing"
import { EventsTitle } from "@/features/companyDetail/components/NewsFeed/EventsTitle/EventsTitle"
import { useArticlesHasFilter } from "@/features/companyDetail/hooks/useArticlesHasFilter"
import { COMPANY_PAGE_TYPE } from "@/modules/companies/api/endpoints/company"
import { useCompanyArticlesFetch } from "@/modules/companies/hooks/useCompanyArticlesFetch"
import { useCompanyEventsFetch } from "@/modules/companies/hooks/useCompanyEventsFetch"
import { useCompanyFetch } from "@/modules/companies/hooks/useCompanyFetch"

export const NewsFeedWrapper: FunctionComponent = () => {
  const { dataCompany } = useCompanyFetch()
  const { dataCompanyEvents, isErrorCompanyEvents } = useCompanyEventsFetch()
  const { dataCompanyArticles, isLoadingCompanyArticles, isSuccessCompanyArticles } = useCompanyArticlesFetch()
  const hasFilters = useArticlesHasFilter()

  const showEvents = !isErrorCompanyEvents && !!dataCompanyEvents && dataCompanyEvents.events.length > 0
  const showLoadingArticles = isLoadingCompanyArticles
  const showArticles =
    !isLoadingCompanyArticles &&
    isSuccessCompanyArticles &&
    dataCompanyArticles &&
    dataCompanyArticles?.articles.length > 0
  const showArticlesEmptyStates =
    !isLoadingCompanyArticles &&
    isSuccessCompanyArticles &&
    dataCompanyArticles &&
    dataCompanyArticles?.articles.length === 0
  const showArticlesFilters = dataCompany?.pageType === COMPANY_PAGE_TYPE.STANDARD ? false : showArticles || hasFilters

  return (
    <>
      {showEvents && (
        <Layout hasBottomPadding colorBlock={LAYOUT_COLOR_BLOCK.WHITE}>
          <Layout.Column>
            <EventsTitle />
            <EventListing />
          </Layout.Column>
        </Layout>
      )}
      <Layout colorBlock={LAYOUT_COLOR_BLOCK.WHITE}>
        <Layout.Column>
          <ArticlesTitle />
          {showArticlesFilters && <ArticlesFilters />}
          {showLoadingArticles && <ArticlesLoading />}
          {showArticles && <ArticleListing />}
          {showArticlesEmptyStates && <ArticlesEmptyStates />}
        </Layout.Column>
      </Layout>
    </>
  )
}
